import { enableProdMode } from '@angular/core';

import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

function loadScript(src: string): void {
	const script = document.createElement('script');
	script.src = src;
	script.async = true;
	const head = document.head;

	head.firstChild ? head.insertBefore(script, head.firstChild) : head.appendChild(script);
}

function loadNoScript(src: string): void {
	const iframe = document.createElement('iframe');
	iframe.src = src;
	iframe.height = '0';
	iframe.width = '0';
	iframe.setAttribute('style', 'display: none; visibility: hidden');
	const noscript = document.createElement('noscript');
	noscript.appendChild(iframe);
	const body = document.body;

	body.insertBefore(noscript, body.firstChild);
}

if (environment.production) {
	enableProdMode();

	// loadScript('https://www.googletagmanager.com/gtag/js?id=G-SXQKJH9Q8J');
	// loadScript('assets/js/gtag.js');
	loadScript('assets/js/gtmtag.js');
	loadNoScript('https://www.googletagmanager.com/ns.html?id=GTM-N4J39KX');
}

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
